import './Toast.css';

function Toast({ message }) {
  if (!message) return null;
  return <div className="admin-toast">{message}</div>;
}

export default Toast;
